module.exports = __webpack_public_path__ + "img/block6-card12.16d24a7b.svg";